import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, isAdmin } from '../../services/auth';

const AdminRoute = ({ element: Element, ...rest }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }
  if (!isAdmin()) {
    // Authenticated but not admin: send to a safe default dashboard
    const userType = localStorage.getItem('userType');
    if (userType === 'Business') return <Navigate to="/businessdash" />;
    if (userType === 'Home') return <Navigate to="/newhome" />;
    return <Navigate to="/" />;
  }
  return <Element {...rest} />;
};

export default AdminRoute;
